import { apiCallAc } from "..";

export function checkVideoStatus(id) {
	return apiCallAc.get(`/dashboard/upload/video/${id}`);
}
